import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplashScreenComponent } from './splash-screen.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [SplashScreenComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [SplashScreenComponent]
})
export class SplashScreenModule { }
